class FloatingSwatchesManager {
  constructor() {
    this.init();
    this.observeAjaxChanges(); // Observe AJAX changes to dynamically update the swatches
  }

  init() {
    this.checkAllVariantsOnLoad();
    document.body.addEventListener('click', this.handleSelectorChange.bind(this));
  }

  checkAllVariantsOnLoad() {
    const allWrapperElements = document.querySelectorAll('.floating-swatches-wrapper');

    allWrapperElements.forEach(wrapper => {
      const productData = this.getProductJsonData(wrapper);
      if (!productData) return;

      productData.variants.forEach(variant => {
        const radioLabel = wrapper.querySelector(`.radio__button input[value="${variant.options}"]`);

        if (radioLabel) {
          if (!variant.available) {
            radioLabel.classList.add('sold-out');
          } else {
            radioLabel.classList.remove('sold-out');
          }
        }
      });
    });
  }

  handleSelectorChange(event) {
    const selectorWrapper = event.target.closest('.floating-swatches-wrapper');
    if (!selectorWrapper) return;

    if (event.target.matches('.product__selectors input')) {
      this.updateVariant(event.target, selectorWrapper);
    }
  }

  updateVariant(input, wrapper) {
    const variantInput = wrapper.querySelector('input[name="id"]');
    const productData = this.getProductJsonData(wrapper);
    if (!productData || !variantInput) return;

    const selectedValue = input.value;
    const variant = productData.variants.find(v => v.options.includes(selectedValue));

    if (variant) {
      variantInput.value = variant.id;
      this.updateAddToCartButton(variant, wrapper);
    } else {
      this.updateAddToCartButton(null, wrapper);
    }
  }

  updateAddToCartButton(variant, wrapper) {
    const addToCartButton = wrapper.querySelector('[data-add-to-cart]');
    const addToCartText = wrapper.querySelector('[data-add-to-cart-text]');
    const formWrapper = wrapper.querySelector('[data-form-wrapper]');

    if (!addToCartButton || !addToCartText) return;

    if (!variant || !variant.available) {
      addToCartButton.disabled = true;
      addToCartText.textContent = 'Sold Out';
      formWrapper.classList.add('variant--soldout');
    } else {
      addToCartButton.disabled = false;
      addToCartText.textContent = 'Add to cart';
      formWrapper.classList.remove('variant--soldout');
      //addToCartButton.click();
      
      this.cartLoadingState(formWrapper)
    }
  }

  cartLoadingState(formWrapper){
    console.log(formWrapper);
    const inner_form = formWrapper.querySelector(".form__inner__wrapper");
    let loading_state = formWrapper.querySelector(".add-cart-loading");
    console.log(inner_form);
    //inner_form.style.display = "none";
    //loading_state.style.display = "block";

    setTimeout(function(){
      inner_form.style.display = "block";
      loading_state.style.display = "none";
    }, 700)
  }

  getProductJsonData(wrapper) {
    const scriptElement = wrapper.querySelector('script[data-product-json]');
    if (!scriptElement) return null;

    try {
      return JSON.parse(scriptElement.innerText);
    } catch (error) {
      console.error('Failed to parse product JSON data:', error);
      return null;
    }
  }

  observeAjaxChanges() {
    const productsGrid = document.querySelector('[data-products-grid]');
    if (!productsGrid) {
      console.warn("No [data-products-grid] element found to observe.");
      return;
    }

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'childList' || mutation.type === 'subtree') {
          this.checkAllVariantsOnLoad(); // Reinitialize floating swatches
        }
      });
    });

    observer.observe(productsGrid, {
      childList: true, // Watch for added/removed children
      subtree: true    // Watch for changes in descendants
    });

    console.log("Observer initialized for [data-products-grid] changes.");
  }
}

// Initialize the class
document.addEventListener('DOMContentLoaded', () => {
  new FloatingSwatchesManager();
});
